export default __webpack_public_path__ + "static/header-iconic-link-products-link-icon2.url-947efa513ea6dc837444380196876b58.svg";